var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { makeStyles, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import InfoIcon from '@material-ui/icons/Info';
import { useTranslation } from 'react-i18next';
import { getMaintenanceBannerKey } from '../../helpers/utils';
import { runningOnCanvas } from '../../utils/canvas';
import { VISIBILITY } from '../../request/appSettings';
export var useStyles = makeStyles(function (theme) {
    var _a;
    return ({
        banner: (_a = {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                zIndex: 3000,
                position: 'fixed',
                top: 0,
                color: 'white',
                padding: '10px'
            },
            _a[theme.breakpoints.down('xs')] = {
                width: '100%',
            },
            _a[theme.breakpoints.up('sm')] = {
                width: '50%',
                left: '25%',
                borderRadius: '5px',
            },
            _a),
        infoContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
        },
        closeButton: {
            color: 'white',
        },
    });
});
export var MaintenanceBanner = function (_a) {
    var message = _a.message, applicationName = _a.applicationName, application = _a.application, _b = _a.severity, severity = _b === void 0 ? 'hight' : _b, _c = _a.visibility, visibility = _c === void 0 ? [] : _c;
    var classes = useStyles();
    var t = useTranslation().t;
    /**
     * Visibility empty => we show the banner for all the cases
     * Else we check for the values in array
     */
    var checkVisibility = function () {
        if (visibility.length > 0) {
            return runningOnCanvas() ? visibility.includes(VISIBILITY.CANVAS) : visibility.includes(VISIBILITY.APP);
        }
        return true;
    };
    var _d = __read(useState(checkVisibility()), 2), visible = _d[0], setVisible = _d[1];
    var onClose = function () {
        setVisible(false);
        // In 24 hours the banner will be shown again
        localStorage.setItem(getMaintenanceBannerKey(application), String(Math.floor((Date.now() + 86400000) / 1000)));
    };
    return (React.createElement(React.Fragment, null, visible
        ? (
        // eslint-disable-next-line no-nested-ternary
        React.createElement("div", { className: classes.banner, style: { backgroundColor: severity === 'hight' ? '#d32f2f' : severity === 'medium' ? '#ff9800' : '#43a047' } },
            React.createElement("div", { className: classes.infoContainer },
                React.createElement(InfoIcon, null),
                React.createElement("div", null, message || t('There will be scheduled maintenance for {{application}} soon.', { applicationName: applicationName }))),
            React.createElement(IconButton, { className: classes.closeButton, "aria-label": "Close", onClick: onClose },
                React.createElement(CloseIcon, null))))
        : null));
};
//# sourceMappingURL=MaintenanceBanner.js.map